<template>
    <div class="CloudClassroomPassage_wrap">

        <el-row :gutter="24">
            <el-page-header @back="goBack" ></el-page-header>
            <el-col :span="19">
                <div class="left_col">
                    <div class="article_title">{{leftInfo.title}}</div>
                    <div class="flex-between article_info">
                        <div><span>原创作者：</span>{{leftInfo.username}}</div>
                        <div><span>发布时间：</span>{{leftInfo.createTime}}</div>
                        <div><span>阅读量：</span>{{leftInfo.browseNum}}</div>
                    </div>
                    <div class="article_content pdf">
                        <!-- :src="leftInfo.dataUrl" -->
                        <!-- :height="iframeH" -->
                        <iframe
                            id='bdIframe'
                            width='100%'
                            frameborder='0'
                            :src='leftInfo.dataUrl'
                        >
                        </iframe>
                    </div>
                </div>
                <div class="pagination">
                    <div class="flex-between change_page">
                        <div @click="getArticleDetail(preArticle.id)">< 上一篇</div>
                        <div @click="getArticleDetail(nextArticle.id)"> 下一篇 ></div>
                    </div>
                    <div class="flex-between">
                        <span>{{preArticle.title}}</span>
                        <span>{{nextArticle.title}}</span>
                    </div>
                </div>
            </el-col>
            <el-col :span="5" :offset="0.5">
                <div class="right_col">
                    <div class="user_info">
                        <div class="user_img"><img :src="leftInfo.userAvatar"></div>
                        <div class="user_name">{{leftInfo.username}}</div>
                        <div class="user_count">共{{leftInfo.totalArticleNum}}篇文章</div>
                        <!-- <div class="user_count">共23篇文章</div> -->
                    </div>
                    <div class="aiticle_list">
                        <div class="sub_title">作者单位其它文章</div>
                        <div class="other_link">
                            <div class="article_link" @click="getArticleDetail(item.id)" v-for="(item,index) in rightInfo.messageList.slice(0,10)" :key="item.id">{{index + 1}}.{{item.title}}</div>
                        </div>
                    </div>
                </div>

            </el-col>
        </el-row>
        <div class="passage_row">

        </div>

    </div>
</template>

<script>
import bus from '../../common/bus';
import { articleDetail } from '../../../utils/api';

export default {
    data() {
        return {
            iframeH: '',
            leftInfo:{
                title:'人工智能基础|K近邻及算法实现',
                author:'麦思多维研究院',
                time:'2021年09月01日',
                readerNum:'223',
                iframeUrl:''
            },
            rightInfo:{
                avatarUrl:'',
                authorName:'麦思多维研究院',
                count:'23',
                messageList:[]
            },
           nextArticle:{
               id:'',
               title:''
           },
           preArticle:{
               id:'',
               title:''
           },
           articleId:this.$route.query.articleId,
           subjectId:this.$route.query.subjectId
        };
    },

    mounted(){
        this.getArticleDetail(this.articleId)
    },
    methods: {
        goBack(){
            this.$router.push({path:'/cloudClassroomProject',query:{subjectId:this.subjectId}})
            // this.$router.push('/cloudClassroom')
        },
        getArticleDetail(id){
            bus.$emit('changeScroll',0)
            articleDetail({ articleId: id }).then(res => {
                this.leftInfo = res.data;
                this.rightInfo.messageList = res.data.relevantArticle;
                this.nextArticle = res.data.nextArticle;
                this.preArticle = res.data.preArticle;
                const oIframe = document.getElementById('bdIframe');
                const deviceHeight = document.documentElement.clientHeight;
                oIframe.style.height = (Number(deviceHeight) + 120) + 'px'; //数字是页面布局高度差
            }).catch(err=>{})
        }
    }
};
</script>

<style lang="scss" scoped>

.CloudClassroomPassage_wrap {
    width: 100%;
    padding: 100px 100px 0px 100px;
    background: #fafbff;
    box-sizing: border-box;
    .left_col{
        background: white;
        padding: 50px 100px 60px 80px;
        box-sizing: border-box;
        // height: 1800px;
        .article_title{
            height: 100px;
            line-height: 100px;
            font-size: 33px;
            letter-spacing: 2px;
            color: #5277F7;
            font-weight: 600;
            text-align: center;
        }
        .article_info{
            font-size: 18px;
            color: #3C3C3C ;
            margin-bottom: 20px;
            span{
                font-weight: 600;
                opacity: 0.8;
            }
        }
    }
    .right_col{
        height: 100%;
        background: white;
        padding: 50px 20px;
        box-sizing: border-box;
        .user_info{
            .user_img{
                text-align: center;
                height: 150px;
                width: 100%;
                img{
                    width: 120px;
                    height: 120px;
                    border-radius: 50%;
                    box-shadow: 0px 3px 6px #EAEEFF;
                    border: 3px solid #e9ecfd;
                }
            }
            .user_name{
                text-align: center;
                color: #3C3C3C;
                font-size: 20px;
                font-weight: 600;
                opacity: 0.8;
            }
            .user_count{
                text-align: center;
                color: #3C3C3C ;
                height: 50px;
                line-height: 50px;
                border-bottom: 1px solid #CBCBCB;
            }
        }
        .aiticle_list{
            color: #5278F7;
            .sub_title{
                height: 90px;
                line-height: 90px;
                color: #3C3C3C;
                font-size: 18px;
                font-weight: 600;
            }
            .article_link{
                height: 50px;
                line-height: 50px;
                font-size: 16px;
            }
            .article_link:hover{
                cursor: pointer;
                color: #FF6206 ;
                opacity: 0.6;
            }


        }
    }
    .pagination{
        padding: 0px 50px;
        color: #3C3C3C ;
        .change_page{
            font-size: 22px;
            color: #5277F7;
            height: 60px;
            line-height: 60px;
            div:hover{
                cursor: pointer;
                color: #FF6206 ;
                opacity: 0.8;
            }
        }
    }
}
</style>
